/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  List,
  Divider,
  ListItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Collapse,
} from '@material-ui/core';
import {
  ChevronLeft,
  Dashboard,
  Help,
  Description,
  InsertDriveFile,
  Event,
  AccessAlarm,
  Group,
  School,
  ExpandLess,
  ExpandMore,
  Class,
  BarChart,
  Folder,
  Timer,
  Notifications,
  FolderShared,
} from '@material-ui/icons';
import MenuItem from './MenuItem';
// import placementTestServices from '../../../redux/services/placementTestServices';

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    overflow: 'auto',
  },
  drawerHeader: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    paddingLeft: '1em',
    ...theme.mixins.toolbar,
  },
  menuTitle: {
    fontFamily: 'Roboto',
    color: '#0000008a',
  },
  menuSubtitle: {
    fontSize: '0.75rem',
    fontFamily: 'Roboto',
    lineHeight: 1.6,
    color: '#0000008a',
  },
  menuCategories: {
    fontSize: '1.25rem',
    fontFamily: 'Roboto',
    lineHeight: 1.6,
    color: '#0000008a',
  },
}));

const MenuStudent = ({
  handleDrawerClose, user, company,
}) => {
  const classes = useStyles();
  const [elearning, setElearning] = useState(false);
  const [elearningOpen, setElearningOpen] = useState(false);
  const [archivesOpen, setArchivesOpen] = useState(false);
  // const [testDone, setTestDone] = useState(false);
  // const history = useHistory();

  useEffect(() => {
    if (company && company.company && company.company.elearningContent) {
      setElearning(company.company.elearningContent);
    }
  }, [company]);

  return (
    <div className={classes.drawerContainer}>
      <div className={classes.drawerHeader}>
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeft />
        </IconButton>
        <Grid container>
          <Grid item md={12}>
            <Typography component="p" variant="body1" className={classes.menuTitle}>
              {`${user.firstname} ${user.name}`}
            </Typography>
          </Grid>
        </Grid>
      </div>
      <Divider />
      <List>
        <ListItem
          component={Link}
          to="/home"
          button
        >
          <ListItemIcon>
            <Dashboard />
          </ListItemIcon>
          <ListItemText primary="Tableau de bord" />
        </ListItem>
        <ListItem
          component={Link}
          to="/agenda/student"
          button
        >
          <ListItemIcon>
            <Event />
          </ListItemIcon>
          <ListItemText primary="Agenda" />
        </ListItem>
        <ListItem
          component={Link}
          to="/groups/student"
          button
        >
          <ListItemIcon>
            <Group />
          </ListItemIcon>
          <ListItemText primary="Formation(s)" />
        </ListItem>

        <ListItem
          component={Link}
          to="/courseplan/student"
          button
        >
          <ListItemIcon>
            <InsertDriveFile />
          </ListItemIcon>
          <ListItemText primary="Plan(s) de formation" />
        </ListItem>

        <ListItem
          component={Link}
          to="/report/student"
          button
        >
          <ListItemIcon>
            <Description />
          </ListItemIcon>
          <ListItemText primary="Rapport(s) de fin de formation" />
        </ListItem>

        <ListItem
          component={Link}
          to="/documents"
          button
        >
          <ListItemIcon>
            <FolderShared />
          </ListItemIcon>
          <ListItemText primary="Documents" />
        </ListItem>

        <ListItem
          component={Link}
          to="/attendance/student"
          button
        >
          <ListItemIcon>
            <AccessAlarm />
          </ListItemIcon>
          <ListItemText primary="Assiduité" />
        </ListItem>
        {elearning && (
        <>
          <ListItem
            onClick={() => setElearningOpen(!elearningOpen)}
            button
          >
            <ListItemIcon>
              <School />
            </ListItemIcon>
            <ListItemText primary="E-learning" />
            {elearningOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={elearningOpen} timeout="auto" unmountOnExit>
            <Divider />
            <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
              <MenuItem
                name="Cours"
                selectedRoute=""
                handleDrawerClose={() => { }}
                route="/e-learning/student"
                icon={<Class />}
              />
              <MenuItem
                name="Résultats"
                selectedRoute=""
                handleDrawerClose={() => { }}
                route="/e-learning/results"
                icon={<BarChart />}
              />

            </List>
            <Divider />
          </Collapse>

        </>

        )}
        <ListItem
          onClick={() => setArchivesOpen(!archivesOpen)}
          button
        >
          <ListItemIcon>
            <Folder />
          </ListItemIcon>
          <ListItemText primary="Archives" />
          {archivesOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={archivesOpen} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem
              name="Notifications"
              selectedRoute=""
              handleDrawerClose={() => { }}
              route="/archives/student/notifications"
              icon={<Notifications />}
            />
            <MenuItem
              name="Assiduité"
              selectedRoute=""
              handleDrawerClose={() => { }}
              route="/archives/student/attendance"
              icon={<Timer />}
            />

          </List>
          <Divider />
        </Collapse>
        <ListItem
          component={Link}
          to="/help"
          button
        >
          <ListItemIcon>
            <Help />
          </ListItemIcon>
          <ListItemText primary="Assistance" />
        </ListItem>
      </List>
    </div>
  );
};

MenuStudent.propTypes = {
  handleDrawerClose: PropTypes.func.isRequired,
};

function mapState(state) {
  const { user } = state.user;
  // eslint-disable-next-line prefer-destructuring
  const company = state.company;
  return { user, company };
}

const actionCreators = {
};

const connectedMenuStudent = connect(mapState, actionCreators)(MenuStudent);

export default withRouter(connectedMenuStudent);
